import { FC } from 'react';
import { useForm } from 'react-final-form';
import { useFieldValue } from 'hooks/useFormHelpers';
import { AdminCartRecipient } from 'store/shoppingCart/types';
import { RecipientOption } from './types';

type Props = {
  cartRecipients: AdminCartRecipient[];
};

export const RemovedRecipientsList: FC<Props> = ({ cartRecipients }) => {
  const { change } = useForm();
  const recipientsSelected = (useFieldValue('recipients_selected') ?? []) as RecipientOption[];
  const selectedIds = new Set(recipientsSelected.map(option => option.value));
  const removedRecipients = cartRecipients.filter(
    recipient => !selectedIds.has(recipient.recipient_id)
  );

  if (!removedRecipients.length) return null;

  const restore = (recipient: AdminCartRecipient) =>
    change('recipients_selected', [
      ...recipientsSelected,
      { value: recipient.recipient_id, label: recipient.recipient_name },
    ]);

  return (
    <div className="shopping-cart-removed-recipients">
      <span className="oath-eyebrow inkBlue">Removed Recipients</span>
      <ul className="shopping-cart-removed-recipients__list">
        {removedRecipients.map(recipient => (
          <li key={recipient.recipient_id} className="shopping-cart-removed-recipients__item">
            <span className="oath-bodysmall gray">{recipient.recipient_name}</span>
            <button
              type="button"
              className="oath-bodysmall link-text inkBlue padding0"
              onClick={() => restore(recipient)}
            >
              Restore
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};
